/**
 * A question-and-answer block.
 *
 * DELIBERATELY NOT AN ACCORDION, for two reasons that both bite this site specifically:
 *
 * 1. `scripts/prerender-body.js` captures the rendered DOM and **fails the build** if anything is
 *    caught at `opacity: 0`. A collapsed accordion is the same class of problem wearing different
 *    CSS: text present in the markup that a visitor cannot see. Always-open sidesteps the argument.
 * 2. These answers ARE the reason the page ranks. The queries this site can realistically win are
 *    questions — "how much deposit do I need", "does checking affect my credit score" — and a
 *    crawler or a language model quoting the page should find the answer next to the question, in
 *    the bytes, with no interaction required.
 *
 * `<h3>` per question so the document outline reads as a list of questions under the section's
 * `<h2>`. That is what makes a passage extractable rather than merely present.
 */
export function Faq({ title = 'Common questions', items, id }) {
  return (
    <section id={id} className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="font-outfit text-2xl md:text-3xl font-bold text-black mb-10">{title}</h2>

        <div className="flex flex-col gap-8">
          {items.map(({ q, a }) => (
            <div key={q}>
              <h3 className="font-outfit text-lg font-semibold text-black mb-2">{q}</h3>
              <div className="text-gray-700 leading-relaxed">{a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
